"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BalanceName = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ticker = require("../../../ticker");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BalanceName = function BalanceName(_ref) {
  var ticker = _ref.ticker,
    value = _ref.value;
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value ? value + ' ' : '', /*#__PURE__*/_react.default.createElement(_ticker.TickerName, {
    ticker: ticker
  }), " ", t('balance'));
};
exports.BalanceName = BalanceName;